import { render, staticRenderFns } from "./FormUserBank.vue?vue&type=template&id=5ad7c7b0&"
import script from "./FormUserBank.vue?vue&type=script&lang=js&"
export * from "./FormUserBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports